const REF_USER = 'userData';
const REF_USER_CONFIGS = 'userConfigsData';
const REF_LANG = 'hmLangCookie';
const REF_AGENT_ID = 'hmAgentId';
const REF_INTERNAL_OAUTH = 'hmClubLoggedFromIntegration';

const ROLES = {
  CONTENT_EDITOR: 'CONTENT_EDITOR',
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MODERATOR: 'MODERATOR'
};

const VIEW_AS_PRODUCER_ROLES = [ROLES.OWNER, ROLES.ADMIN, ROLES.CONTENT_EDITOR];

export {
  REF_AGENT_ID,
  REF_INTERNAL_OAUTH,
  REF_LANG,
  REF_USER_CONFIGS,
  REF_USER,
  ROLES,
  VIEW_AS_PRODUCER_ROLES
};
